
import { Navigate, useLocation } from "react-router-dom";

const normalizeRole = (role = "") => {
  return role
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[\s_-]/g, "");
};

const isJwtExpired = (token) => {
  if (!token) return true;

  try {
    const payloadPart = token.split(".")[1];
    if (!payloadPart) return true;

    const normalizedPayload = payloadPart
      .replace(/-/g, "+")
      .replace(/_/g, "/");

    const paddedPayload = normalizedPayload.padEnd(
      Math.ceil(normalizedPayload.length / 4) * 4,
      "="
    );

    const payload = JSON.parse(atob(paddedPayload));

    return !payload.exp || payload.exp * 1000 <= Date.now();
  } catch (error) {
    console.error("Invalid JWT token:", error);
    return true;
  }
};

const clearExpiredSession = () => {
  localStorage.clear();
};

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const location = useLocation();

  const token = localStorage.getItem("token");
  const refreshToken = localStorage.getItem("refresh_token");
  const storedUser = localStorage.getItem("user");

  // User is not logged in
  if (!token) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // The refresh token represents the complete login session. An expired
  // access token is allowed while the refresh token is valid because api.js
  // will silently obtain a new access token on the next API request.
  const sessionExpired = refreshToken
    ? isJwtExpired(refreshToken)
    : isJwtExpired(token);

  if (sessionExpired) {
    clearExpiredSession();
    return <Navigate to="/?expired=true" replace />;
  }

  let user = null;

  try {
    user = storedUser ? JSON.parse(storedUser) : null;
  } catch (error) {
    console.error("Invalid user data in localStorage:", error);
    clearExpiredSession();

    return <Navigate to="/" replace />;
  }

  // Handle both possible department property names
  const currentUserRole = normalizeRole(
    user?.department || user?.usr_department || ""
  );

  const normalizedAllowedRoles = allowedRoles.map(normalizeRole);

  console.log("Logged-in user:", user);
  console.log("Current user department:", currentUserRole);
  console.log("Allowed departments:", normalizedAllowedRoles);

  // Check whether user has permission
  if (
    normalizedAllowedRoles.length > 0 &&
    !normalizedAllowedRoles.includes(currentUserRole)
  ) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;
